<template>
    <v-dialog :value="value" max-width="500" persistent @input="$emit('input', $event)">
        <v-card>
            <v-card-title class="font-weight-bold">
                Redefinir Senha
            </v-card-title>
            <v-card-text>
                <p class="mb-4">
                    Informe o código recebido no e-mail e defina sua nova senha.
                </p>
                <v-form ref="form">
                    <v-row>
                        <v-col>
                            <v-text-field
                                v-model="code"
                                label="Código"
                                outlined
                                dense
                                hide-details="auto"
                                :rules="[rules.required]"
                            />
                        </v-col>
                    </v-row>
                    <v-row>
                        <v-col>
                            <v-text-field
                                v-model="password"
                                label="Nova senha"
                                :type="showPassword ? 'text' : 'password'"
                                :append-icon="showPassword ? 'mdi-eye' : 'mdi-eye-off'"
                                @click:append="showPassword = !showPassword"
                                outlined
                                dense
                                hide-details="auto"
                                :rules="[rules.required, rules.min]"
                            />
                        </v-col>
                    </v-row>
                    <v-row>
                        <v-col>
                            <v-text-field
                                v-model="passwordConfirm"
                                label="Confirmar nova senha"
                                :type="showPassword ? 'text' : 'password'"
                                :append-icon="showPassword ? 'mdi-eye' : 'mdi-eye-off'"
                                @click:append="showPassword = !showPassword"
                                outlined
                                dense
                                hide-details="auto"
                                :rules="[rules.required, matchPassword]"
                            />
                        </v-col>
                    </v-row>
                </v-form>
            </v-card-text>
            <v-card-actions class="justify-end px-6 pb-4">
                <v-btn text color="grey" @click="close">
                    Cancelar
                </v-btn>
                <v-btn color="primary" elevation="0" :loading="loading" @click="submit">
                    Redefinir
                </v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>
</template>

<script>
import axios from 'axios';

export default {
    name: 'ResetPasswordWithCode',

    props: {
        value: { type: Boolean, default: false },
        email: { type: String, default: '' },
    },

    data: () => ({
        loading: false,
        showPassword: false,
        code: '',
        password: '',
        passwordConfirm: '',
        rules: {
            required: v => !!v || 'Campo obrigatório.',
            min: v => (v && v.length >= 6) || 'Mínimo 6 caracteres.',
        },
    }),

    methods: {
        matchPassword(v) {
            return v === this.password || 'Senhas não conferem.';
        },

        close() {
            this.code = '';
            this.password = '';
            this.passwordConfirm = '';
            this.$refs.form && this.$refs.form.resetValidation();
            this.$emit('input', false);
        },

        async submit() {
            if (!this.$refs.form.validate()) return;

            this.loading = true;

            try {
                await axios.post('/api/admin/client/reset-password', {
                    email: this.email,
                    code: this.code,
                    newPassword: this.password,
                });

                this.$emit('input', false);
                this.$dialog.notify.success('Senha redefinida com sucesso!', { position: 'top-right', timeout: 3000 });

                this.code = '';
                this.password = '';
                this.passwordConfirm = '';
            } catch (error) {
                const msg = error.response && error.response.data && error.response.data.content
                    ? error.response.data.content.error.message
                    : 'Erro ao redefinir senha';
                this.$dialog.notify.error(msg, { position: 'top-right', timeout: 5000 });
            } finally {
                this.loading = false;
            }
        },
    },
};
</script>
